import { useRouter } from 'next/router';
import { PricesStyle } from '../../styles/components/country';
import Button from '../common/ui/Button';
export interface IPricesProps {
  services: IServiceProps[];
}

export interface IServiceProps {
  title: string;
  description: string;
  button: { text: string; link?: string; action?: () => void };
  price: string;
  fromLabel?: string;
  feesIncludedLabel: string;
}

const Prices = (props: IPricesProps) => {
  return (
    <div className={PricesStyle.pricesWrap}>
      <div className={PricesStyle.prices}>
        {(props.services as IServiceProps[]).map((data: any, index: number) => {
          return <ServiceComponent key={index} {...data} />;
        })}
      </div>
    </div>
  );
};

const ServiceComponent = (props: IServiceProps) => {
  const router = useRouter();

  return (
    <div className={PricesStyle.serviceWrap}>
      <div className={PricesStyle.service}>
        <div className={PricesStyle['leftContent']}>
          <h2>{props.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: props.description }} />
        </div>
        <div className={PricesStyle['rightContent']}>
          <div className={PricesStyle['rightContentWrapper']}>
            <div className={PricesStyle['priceService']}>
              {props.fromLabel && <span>{props.fromLabel}</span>}
              <span>{props.price}</span>
            </div>
            <p>{props.feesIncludedLabel}</p>
            <Button
              color={'cta'}
              onClick={() => {
                if (props.button.link) {
                  router.push(props.button.link);
                }

                if (props.button.action) {
                  props.button.action();
                }
              }}>
              {props.button.text}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Prices;
